import { createFileRoute } from "@tanstack/react-router";
import { DropdownExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute(
  "/demo/design-system/interactive/dropdown",
)({
  component: DropdownExamples,
});
